import React, { memo } from 'react'
import { CurrencyInput } from 'transfix-ui/components/CurrencyInput'
import { Rate } from 'apps/fleet-planner/components/load-details/Details'
import { LockedTooltip } from 'apps/fleet-planner/components/load-details/LockedTooltip'
import { LOAD_FIELDS } from 'apps/fleet-planner/utils/permissions'
import { Button, Card, InlineEditContainer } from 'transfix-ui'

interface RateInlineEditProps {
  rate?: string
  currentEditField?: string
  onEditModeRequested: (name?: string) => void
  onChange: (rate?: string) => void
  onSave: () => void
  onCancel: () => void
  isLocked?: boolean
  isLoading?: boolean
}

export const MAX_RATE = 1000000
export const isValidRate = (rate?: string) => {
  return typeof rate !== 'undefined' && rate !== null && rate.length > 0
    ? parseFloat(rate) < MAX_RATE
    : true
}

export const RateInlineEdit = memo<RateInlineEditProps>(
  ({
    currentEditField,
    isLoading,
    isLocked,
    onCancel,
    onChange,
    onEditModeRequested,
    onSave,
    rate,
  }) => {
    const NAME = LOAD_FIELDS.rate
    const isEditMode = currentEditField === NAME

    const onChangeHandler = (e: { value: string; id: string }) => {
      onChange(e.value)
    }

    const isValid = isValidRate(rate)

    return (
      <InlineEditContainer
        isLoading={isLoading}
        isLocked={isLocked}
        lockedIcon={<LockedTooltip className='locked-icon' />}
        dataTest='load-details-rate-section'
        name={NAME}
        editModeEnabled={isEditMode}
        onEditModeRequested={onEditModeRequested}
        resetOnClickOutside={false}
        editMode={
          <Card className='pa4'>
            <CurrencyInput
              placeholder='$'
              value={rate ? Number(rate) : undefined}
              onChange={onChangeHandler}
              dataTest='inline-edit-rate'
              large
              invalid={!isValid}
              validationMessage={!isValid ? `Rates must be under $${MAX_RATE}` : ''}
            />
            <div className='tr'>
              <div className='mt4'>
                <Button
                  color='tertiary'
                  size='large'
                  onClick={onCancel}
                  data-test='load-rate-cancel'>
                  Cancel
                </Button>
                <Button
                  color='primary'
                  size='large'
                  onClick={onSave}
                  disabled={!isValid}
                  data-test='load-rate-submit'>
                  Save
                </Button>
              </div>
            </div>
          </Card>
        }>
        <Rate rate={rate} />
      </InlineEditContainer>
    )
  }
)
